import { useRef } from 'react';

const useMoengage = () => {
  const maxTry = useRef(1);
  const loginUser = useRef(null);

  const createMoengageUser = (userId, name, phoneNumber) => {
    if (!loginUser.current) {
      if (window.Moengage) {
        window.Moengage.add_unique_user_id(userId);
        window.Moengage.add_user_name(name);
        window.Moengage.add_mobile(phoneNumber);
        loginUser.current = userId;
      } else if (maxTry.current < 3) {
        maxTry.current += 1;
        const timer = setTimeout(() => {
          createMoengageUser(userId, name, phoneNumber);
          loginUser.current = userId;
          clearTimeout(timer);
        }, 1000);
      }
    }
  };

  const trackEvent = (eventName, eventAttributes = {}) => {
    if (window.Moengage) {
      window.Moengage.track_event(eventName, eventAttributes);
    } else if (maxTry.current < 3) {
      maxTry.current += 1;
      const timer = setTimeout(() => {
        trackEvent(eventName, eventAttributes);
        clearTimeout(timer);
      }, 1000);
    }
  };

  const triggerContentInteractedEvent = (type, value) => {
    let eventAttributes = {};
    if (Object.keys(value).length) {
      eventAttributes = { ...eventAttributes, ...value };
    } else {
      eventAttributes = {
        value,
      };
    }
    trackEvent('content_interacted', {
      type,
      ...eventAttributes,
    });
  };

  return [createMoengageUser, trackEvent, triggerContentInteractedEvent];
};

export default useMoengage;
